export default {"src":"/_next/static/media/courses-2.c56b472e.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};